import { createFileRoute } from '@tanstack/react-router';
import { AccountingPeriodsPage } from '@/features/accounting/parameters/generalites/components/AccountingPeriodsPage';

export const Route = createFileRoute('/$commiteeSlug/accounting/parameters/account-periods')({
  component: AccountingPeriodsPage,
});
